var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Theme from '@amzn/meridian/theme';
import { createContext, useContext } from 'react';
/**
 * The font tokens App put on its <Theme> (the Ember Modern tokens in the font modernization
 * T1 arm, undefined otherwise). Undefined outside App, e.g. the router's errorElement.
 */
const FontTokensContext = createContext(undefined);
/**
 * Use instead of a nested Meridian <Theme>. A nested <Theme> re-resolves its tokens from palette
 * and mode and drops the ones set above it, so this passes App's font tokens again. With no
 * font tokens it renders exactly like a plain <Theme>.
 */
export const NestedTheme = (props) => _jsx(Theme, Object.assign({}, props, { tokens: useContext(FontTokensContext) }));
/**
 * App's own <Theme>: a Meridian <Theme> that also publishes its font tokens on FontTokensContext,
 * so NestedTheme can re-pass them further down. Named for the role, not the tokens, so any future
 * app-wide theme value can be added here.
 */
export const AppTheme = (_a) => {
    var { fontTokens, children } = _a, props = __rest(_a, ["fontTokens", "children"]);
    return (_jsx(Theme, Object.assign({}, props, { tokens: fontTokens, children: _jsx(FontTokensContext.Provider, { value: fontTokens, children: children }) })));
};
